<template>
  <BadgeSquare v-if="names" :badgeText="names" :grey="true" size="extra-small" />
</template>

<script setup lang="ts">
import BadgeSquare from '@/design-system/atoms/BadgeSquare.vue'
import { ref, toRefs, watch } from 'vue'
import { CoreEntityDto } from '@/interfaces/core.interface'
import { useCoreEntityStore } from '@/pinia/coreEntity'

type Props = {
  entityConnectionPath: string[]
}

const props = defineProps<Props>()
const coreEntityStore = useCoreEntityStore()
const { entityConnectionPath } = toRefs(props)
const names = ref<string>()

async function getCoreEntityNames(entityConnectionPath: string[]): Promise<string | undefined> {
  if (!entityConnectionPath?.length) {
    return undefined
  }
  let parents: CoreEntityDto[] = []
  for (const entityId of entityConnectionPath) {
    const coreEntity = await coreEntityStore.getCoreEntity(entityId)
    if (coreEntity) {
      parents.push(coreEntity)
    }
  }
  return parents?.map((parent) => parent.displayName).join(', ')
}

watch(
  entityConnectionPath,
  async (newValue) => {
    if (!newValue) return
    const parents = await getCoreEntityNames(newValue)
    if (!parents) return
    names.value = parents
  },
  { immediate: true }
)
</script>
